<div id="single-chart-wrapper" class="flex justify-content-start align-items-center p-20" data-cy="hammer-rating-area">
  <div id="hammerRatingChart0" [attr.data-cy]="title + '-hammer-rating-chart'"></div>
  <div>
    <h1 data-cy="hammer-rating-product-installation-type">{{ title }}</h1>
    <h2 data-cy="hammer-rating-area-title"><strong>Verified Trade Index (VTI)</strong></h2>
  </div>
</div>
